import { Component } from '@angular/core';
import { NavController, Events, App, LoadingController, NavParams } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { SpecialCommon } from './special.common';
import { SpecialData } from '../../providers/special-data';
import { Observable } from 'rxjs/Observable';

@Component({
	selector: 'page-special-full',
  	templateUrl: 'special.full.html'
})

export class SpecialPageFull extends PageBaseFull {
	
	public fullTopMenus = [];
	public fullBottomMenus = [];
	public showHideCategories = false;
	public damCategories: any;
	public damProducts : any;
	public loader: any;
	public categoryUrlSlug = 'all';
	public category = {};
	public damProductsList: any;
	

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: SpecialCommon,
		public app: App,
		public specialData: SpecialData,
		public loadingCtrl: LoadingController,
		private navParams: NavParams,
		
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
		//console.log("Loading Weekly Ad Full");
		this.categoryUrlSlug = navParams.get('categoryUrlSlug');
		this.showHideCategories = navParams.get('showHideCategories');
	}
	
	ionViewDidEnter() {
		this.app.setTitle('Special');
		this.appendFooterScripts('assets-full/base/js/scripts/pages/isotope-grid.js');
	}

	ngAfterViewInit() {
		this.common.commonMethod();	
		this.loadData();	
	}

	public loadData() {
		var self = this;
		self.loader.present();
		if(self.categoryUrlSlug && self.categoryUrlSlug != '' && self.categoryUrlSlug != 'all'){
			self.getAllWeeklyAdCategoriesData().subscribe(categoriesRes => {
				self.loader.dismiss();
				console.log(categoriesRes);
				self.category = _.find(categoriesRes, (value, key) => {
					return value.urlSlug == self.categoryUrlSlug;
				});
				self.getDamByCategory(self.category);
			});
		}else{
			Observable.from([self.getAllDamProductsData(), self.getAllWeeklyAdCategoriesData()]).combineAll().subscribe(() => {
				self.loader.dismiss();
			});
		}
	}

	public getAllWeeklyAdCategoriesData() {
		return this.specialData.getAllDamCategories().map(damCategories => {
			if (damCategories) {
				this.damCategories = damCategories;
			}
			return damCategories;
		});
	}

	public getDamByCategory(category) {
		this.categoryUrlSlug = category.urlSlug;
		this.getLocalDamProducts().subscribe(damProducts => {
			if (damProducts) {
				this.damProductsList = _.filter(damProducts, damProduct => {
					return _.find(damProduct['categories'], (value, key) => {
						return key == category.$key;
					});
				});
			}
		});
	}

	public getLocalDamProducts() {
		return this.specialData.getLocalDamProducts();
	}

	public getAllDamProductsData() {
		this.categoryUrlSlug = 'all';
		return this.specialData.getAllDamProductsFullData().map(damProducts => {
			this.damProductsList = damProducts;
			// this.saveRecipesToLocalStorage();
			return damProducts;
		});
	}

	damProductsByCatory(categoryUrlSlug) {
		//this.showHideCategories = true;
		if(!categoryUrlSlug)
			categoryUrlSlug = 'all';
		this.nav.push(SpecialPageFull, { categoryUrlSlug: categoryUrlSlug });

	}
}



// WEBPACK FOOTER //
// ./src/modules/special/pages/special/special.full.ts